import { useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'src/AppContext';
import Button from 'src/components/Button';
import { useFormInputAccountPassword, useFormInputEmail } from 'src/components/FormInput';
import { ACCOUNT_EMAIL_VALIDATE_ERROR, ACCOUNT_PASSWORD_CONFIRM_VALIDATE_ERROR } from 'src/constants/validate';

export default function AccountForm({ isShow }: AccountProcessProps): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const emailInput = useFormInputEmail({
    errors: ACCOUNT_EMAIL_VALIDATE_ERROR,
    inputAttr: {
      placeholder: 'account/form/email_placeholder',
    },
  });
  const passwordInput = useFormInputAccountPassword();
  const passwordConfirmInput = useFormInputAccountPassword({
    label: t('account/form/password_confirm_title'),
    name: 'passwordConfirm',
    validate: {
      required: (value: string) => !!value,
      match: (value: string) => passwordInput.value === value,
    },
    inputAttr: {
      placeholder: 'account/form/password_confirm_placeholder',
    },
    errors: ACCOUNT_PASSWORD_CONFIRM_VALIDATE_ERROR,
  });

  useEffect(() => {
    if (passwordInput.value !== '' && passwordConfirmInput.value !== '') {
      passwordConfirmInput.triggerValidate();
      passwordInput.triggerValidate();
    }
  }, [passwordInput.value, passwordConfirmInput.value]);

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  return (
    <div className={isShow ? '' : 'hidden'}>
      <div className="container mt-6">
        <h1 className="N_20_R">{t('account/form/title')}</h1>
        <div className="mt-7">{emailInput.CustomFormInput}</div>
        <div className="mt-5">{passwordInput.CustomFormInput}</div>
        <div className="mt-5">{passwordConfirmInput.CustomFormInput}</div>
        <div className="mt-6">
          <Button
            title={t('account/form/complete_button')}
            disabled={!(emailInput.isValid && passwordInput.isValid && passwordConfirmInput.isValid)}
            type="submit"
          ></Button>
        </div>
      </div>
      <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
        <li>{t('account/form/disclaimer_1')}</li>
      </ul>
    </div>
  );
}
